<template>
	<v-dialog v-model="localDialog" max-width="653" transition="dialog-transition" content-class="round">
		<service-selector title="Connect a New Profile" v-if="localDialog && !preselectApp" @select-app="selectApp" />
		<AddProfile v-bind="addProfileBindData" ref="profileManager" v-if="selectedApp" />
	</v-dialog>
</template>

<script>
import { buildProfileObj } from '@/utils/helpers';
import { mapActions, mapGetters } from 'vuex';
import CredentialsService from '@/utils/credentials-service';
import ServiceSelector from '@/components/Settings/ServiceSelector.vue';
import { ProjectPermissions } from '@ply-io/ply-front-shared-utilities';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { ALL_PROJECTS_VIRTUAL_ID } from '@/utils/projects.const';
export default {
	name: 'ProfileConnectNewDialog',
	components: {
		ServiceSelector,
	},
	props: {
		showDialog: { type: Boolean },
		preselectApp: { type: Object },
		projectId: { type: [Number, String] },
	},
	computed: {
		...mapGetters('main', ['appURL', 'appApiURL']),
		...mapGetters('projects', ['projectHasPermission']),
		...mapGetters('credentials', ['getCredentialData']),
		addProfileBindData() {
			return buildProfileObj(this.selectedApp);
		},
		canChangeProjectCredentials() {
			if (this.projectId === ALL_PROJECTS_VIRTUAL_ID) {
				return true;
			}
			return this.projectHasPermission(this.projectId, ProjectPermissions.ChangeCredentials);
		},
	},
	methods: {
		...mapActions(['credentials/getUserCredentials', 'credentials/getCredentialData']),
		getAppProfiles() {
			this['credentials/getUserCredentials']({ forceGet: true });
		},
		selectApp(app) {
			this.$set(this, 'selectedApp', app);
			this.$nextTick(() =>
				this.$refs.profileManager.startAddProfile({
					app,
					apiURL: this.appApiURL,
					appURL: this.appURL,
					callback: this.clearData,
					getAppProfiles: this.getAppProfiles,
				})
			);
		},
		async clearData(newCredentialsId) {
			this.selectedApp = null;
			this.localDialog = false;
			if (newCredentialsId && this.canChangeProjectCredentials) {
				const newCredentials = await this['credentials/getCredentialData']({ id: newCredentialsId });
				if (CredentialsService.isConnectionStatusSuccessful(newCredentials)) {
					AppDialogManagerService.openUpdateProjectConnectionDialog({
						projectId: !this.projectId || isNaN(this.projectId) ? null : Number(this.projectId),
						credentialsId: newCredentialsId,
					});
				}
			}
		},
	},
	watch: {
		showDialog: {
			handler(newV) {
				this.localDialog = newV;
				this.stage = 1;
				this.searchString = '';
			},
			immediate: true,
		},
		localDialog: {
			handler(newV) {
				this.$emit('update:showDialog', newV);
				if (newV && this.preselectApp) {
					this.selectApp(this.preselectApp);
				}
			},
		},
	},
	data: () => ({
		stage: 1,
		localDialog: null,
		selectedApp: null,
		popUp: null,
		popUpTimer: null,
	}),
	mounted() {},
};
</script>

<style scoped lang="scss"></style>
